// src/components/Loader.js
import React from 'react';

const Loader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[99999]">
      <div className="flex flex-col items-center space-y-4">
        {/* Adjusted the border size and gap to make the rotation clearer */}
        <div className="w-[65px] h-[65px] border-4 border-t-4 border-red-500 rounded-full animate-spin"></div>
        {/* Optional text */}
        <p className="text-white text-lg font-semibold animate-pulse">Loading, please wait...</p>
      </div>
    </div>
  );
};

export default Loader;
